import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import StartProjectModal from "@/components/StartProjectModal";

export const Layout = () => {
  const location = useLocation();

  // Scroll to top on route change.
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <>
      <Nav />
      <main>
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
      <StartProjectModal />
    </>
  );
};

export default Layout;
